export const removeAllWhitespace = (str: string) => str.replace(/\s+/g, '');

/**
 * It capitalizes the first letter of each word in a string, with optional custom split and join characters.
 *
 * - If no split character is provided, it defaults to splitting by spaces.
 * - If no join character is provided, it defaults to using the split character or space if none is provided.
 */
export const capitalizeByCharacter = (text: string, splitChar?: string, joinChar = splitChar): string => {
  const newSplitChar = splitChar ?? ' ';

  const newJoinChar = joinChar ?? newSplitChar;

  const value = text
    .toLowerCase()
    .split(newSplitChar)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(newJoinChar);

  return value;
};

/**
 * Removes all HTML tags from a text string.
 * @param input - Text that may contain HTML tags.
 * @returns The text without any HTML tags.
 */
export const removeHtmlTags = (input: string): string => input.replace(/<[^>]*>/g, '');
